import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { KeyRound, ShieldCheck } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

const Security = () => {
  const { toast } = useToast();
  const [configured, setConfigured] = useState(null);
  const [accessPassword, setAccessPassword] = useState('');
  const [transactionPassword, setTransactionPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const loadStatus = async () => {
    try {
      const response = await api.get('/me/security/transaction-password');
      setConfigured(Boolean(response.data?.configured));
    } catch {
      setConfigured(false);
    }
  };

  useEffect(() => { loadStatus(); }, []);

  const save = async (event) => {
    event.preventDefault();
    if (!/^\d{6}$/.test(transactionPassword)) return toast({ variant: 'destructive', title: 'Senha inválida', description: 'Use exatamente 6 dígitos numéricos.' });
    if (transactionPassword !== confirmPassword) return toast({ variant: 'destructive', title: 'Confirmação diferente', description: 'As duas senhas transacionais devem ser iguais.' });
    if (!accessPassword) return toast({ variant: 'destructive', title: 'Senha de acesso obrigatória', description: 'Confirme sua senha de acesso para salvar.' });

    setLoading(true);
    try {
      await api.post('/me/security/transaction-password', { accessPassword, transactionPassword });
      toast({ title: configured ? 'Senha transacional alterada' : 'Senha transacional criada', description: 'Movimentações financeiras agora exigirão essa credencial.' });
      setAccessPassword(''); setTransactionPassword(''); setConfirmPassword(''); setConfigured(true);
    } catch (error) {
      toast({ variant: 'destructive', title: 'Não foi possível salvar', description: error.response?.data?.detail || 'Confira os dados informados.' });
    } finally { setLoading(false); }
  };

  return <div className="space-y-8" data-testid="customer-security-page">
    <div><h1 className="text-4xl font-bold tracking-tight">Segurança</h1><p className="mt-2 text-muted-foreground">Gerencie a credencial usada para autorizar movimentações financeiras.</p></div>
    <Card className="max-w-2xl"><CardHeader><CardTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5" />Senha transacional</CardTitle><CardDescription>{configured ? 'Sua senha transacional já está configurada. Você pode alterá-la abaixo.' : 'Crie uma senha de 6 dígitos diferente da senha usada para entrar no ItechPay.'}</CardDescription></CardHeader><CardContent>
      <div className="mb-6 flex items-start gap-3 rounded-lg border p-4"><ShieldCheck className="mt-0.5 h-5 w-5" /><div><p className="font-medium">Credenciais separadas</p><p className="text-sm text-muted-foreground">A senha de acesso abre o sistema. A senha transacional autoriza transferências e, futuramente, Pix e pagamentos.</p></div></div>
      <form onSubmit={save} className="space-y-5"><div className="space-y-2"><Label>Senha de acesso atual</Label><Input type="password" autoComplete="current-password" value={accessPassword} onChange={(e) => setAccessPassword(e.target.value)} /></div><div className="grid gap-4 md:grid-cols-2"><div className="space-y-2"><Label>{configured ? 'Nova senha transacional' : 'Senha transacional'}</Label><Input type="password" inputMode="numeric" autoComplete="off" maxLength={6} placeholder="6 dígitos" value={transactionPassword} onChange={(e) => setTransactionPassword(e.target.value.replace(/\D/g, '').slice(0, 6))} /></div><div className="space-y-2"><Label>Confirmar senha transacional</Label><Input type="password" inputMode="numeric" autoComplete="off" maxLength={6} placeholder="Repita os 6 dígitos" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value.replace(/\D/g, '').slice(0, 6))} /></div></div><div className="flex justify-end"><Button type="submit" disabled={loading}>{loading ? 'Salvando...' : configured ? 'Alterar senha transacional' : 'Criar senha transacional'}</Button></div></form>
    </CardContent></Card>
  </div>;
};

export default Security;
